/*
* Project: LegalPlace assistant
* File: src/redux/reducers/document_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import {
  NEW_DOCUMENT,
  CONTINUE_DOCUMENT,
  SET_CONTRACT_NAME,
  SET_USER_ID,
  SET_DOCUMENT_ID,
} from '../actions/document_state';
import lpApp from '../../app/lp_app';
import writeHistory from '../../logic/history';
// import { Map } from 'immutable';

export function documentStateReducer(state = {
  state: 'new', doc_name: '', unique: '', user_id: '',
}, action) {
  const result = state;
  // cloning
  switch (action.type) {
    case NEW_DOCUMENT:
      result.state = 'new';
      break;
    case CONTINUE_DOCUMENT:
      result.state = 'continue';
      result.unique = action.id;
      // writeHistory(false, true, 0, action.id);
      break;
    case SET_CONTRACT_NAME:
      result.doc_name = action.name;
      break;
    case SET_USER_ID:
      result.user_id = action.id;
      break;
    case SET_DOCUMENT_ID:
      result.state = 'continue';
      result.unique = action.doc;
      result.doc_name = lpApp.contractTitle;
      break;
    default:
      break;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/document_state.js